import { SitesData } from '../../Job/jobStarter/addJob/components/customerSiteInfo/addSiteModal/utils/Type';
import { SiteListingDetails } from '../../Job/jobStarter/addJob/utils/types';

export function formatInspectionSitesTableData(data: SiteListingDetails[]) {
  if (data.length === 0) {
    return [];
  }

  const res: SitesData[] = [];

  data.forEach((col: SiteListingDetails) => {
    const obj = {
      select: '',
      siteID: '',
      siteName: '',
      address: '',
      country: '',
      city: '',
      state: '',
      pincode: '',
      id: '',
    };

    obj.siteID = col?.SiteId;
    obj.siteName = col.SiteName;
    obj.address = col.Address;
    obj.city = col.City;
    obj.state = col.State;
    obj.id = col.SiteId;
    obj.country = col.Country;
    obj.pincode = col?.Pincode;
    res.push(obj);
  });

  return res;
}
